import {
    SET_DEFINITION,
    SET_DEFINITIONS
  } from "./actions";
import produce from "immer";
import SelectionState from 'state/selections/SelectionState';
import {COMMIT_SELECTIONS} from 'state/selections/actions';

const defaultState = {
    definitions: {
        [SelectionState.UNCOMMITTED]: [],
        [SelectionState.COMMITTED]: []
      },
      fetchingData: {
       // [SummaryType.ABSOLUTE]: false,
        //[SummaryType.RELATIVE]: false,
      },
      data: {
        //[SummaryType.ABSOLUTE]: null,
       // [SummaryType.RELATIVE]: null
      },
    };

    export default produce(
        (state = defaultState, action) => {
            switch (action.type) {
                  case SET_DEFINITION: {
                      const {definition, idx} = action;
                      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
                      if (definition === null) {
                        selectedDefinitions.splice(idx, 1);
                      } else {
                        selectedDefinitions[idx] = definition;
                      }
                      break;
                  }

                  case  SET_DEFINITIONS : {
                    state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
                    break;
                  }
                  case COMMIT_SELECTIONS: {         
                    state.definitions[SelectionState.COMMITTED] = state.definitions[SelectionState.UNCOMMITTED];
                    break;
                  }
                  default:
                    return state;

            }
        }
    )